// Chat Service for AI Assistant
const API_BASE_URL = 'http://localhost:3000/api';

export const chatService = {
  // Send message to AI assistant
  async sendMessage(message) {
    try {
      const response = await fetch(`${API_BASE_URL}/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message }),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Chat service error:', error);
      throw error;
    }
  },

  // Send message to Copilot
  async sendToCopilot(message, context = '') {
    try {
      const response = await fetch(`${API_BASE_URL}/copilot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          message,
          context,
          provider: 'github'
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send to Copilot');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Copilot service error:', error);
      throw error;
    }
  }
};
